module.exports = __webpack_public_path__ + "img/imac.1dc7fe27.webp";